import { jsx as p } from "@emotion/react/jsx-runtime";
import o from "prop-types";
import { css as e, jsx as g } from "@emotion/react";
import { FONTS as s, COLORS as T } from "../../constants.mjs";
import { makeStyles as u } from "../../theme.mjs";
const r = {
  base: e`
        margin: 0;
    `,
  font1: e`
        font-family: ${s.PRIMARY};
        font-weight: 300;
        font-size: 2.5rem;
        line-height: 1.2;
        letter-spacing: -0.02em;
        white-space: pre-line;
    `,
  font2: e`
        font-family: ${s.PRIMARY};
        font-weight: 700;
        font-size: 1rem;
        line-height: 1.5rem;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        white-space: pre-line;
    `,
  font3: e`
        font-family: ${s.PRIMARY};
        font-weight: 500;
        font-size: 1rem;
        line-height: 1.5rem;
        white-space: pre-line;
    `,
  font4: e`
        font-family: ${s.PRIMARY};
        font-weight: 400;
        font-size: 1rem;
        line-height: 1.5rem;
        white-space: pre-line;
        white-space: inherit;
        overflow: inherit;
        text-overflow: inherit;
    `,
  font5: e`
        font-family: ${s.PRIMARY};
        font-weight: 500;
        font-size: 0.875rem;
        line-height: 1.5rem;
        white-space: pre-line;
        white-space: inherit;
        overflow: inherit;
        text-overflow: inherit;
    `,
  display: e`
        font-family: ${s.PRIMARY};
        font-weight: 600;
        line-height: 1.1;
        letter-spacing: -0.02em;
    `,
  displayXXS: e`
        font-size: 1.5rem;
        line-height: 1.75rem;
    `,
  displayXS: e`
        font-size: 2rem;
        line-height: 2.375rem;
    `,
  displayS: e`
        font-size: 2.5rem;
        line-height: 3rem;
    `,
  displayM: e`
        font-size: 3rem;
        line-height: 3.5rem;
    `,
  displayL: e`
        font-size: 3.5rem;
        line-height: 4rem;
    `,
  displayXL: e`
        font-size: 4rem;
        letter-spacing: inherit;
        line-height: 4.5rem;
    `,
  text: e`
        font-family: ${s.PRIMARY};
        font-weight: 500;
        line-height: 1.5rem;
    `,
  textXS: e`
        font-size: 0.75rem;
        line-height: 1rem;
    `,
  textS_XS: e`
        font-size: 0.875rem;
        line-height: 1.25rem;
    `,
  textS: e`
        font-size: 1rem;
        line-height: 1.5rem;
    `,
  textM: e`
        font-size: 1.25rem;
        line-height: 1.5rem;
    `,
  textL: e`
        font-size: 1.5rem;
        line-height: 2rem;
    `,
  textXL: e`
        font-size: 2rem;
        line-height: 2.5rem;
    `,
  textuppercase: e`
        text-transform: uppercase;
        letter-spacing: 0.1em;
        font-weight: 600;
    `,
  textBold: e`
        font-weight: 600;
    `
}, x = u((t, n = t.colors.text) => ({
  text: e`
        color: ${n};
    `
})), a = {
  XS: "XS",
  S_XS: "S_XS",
  S: "S",
  M: "M",
  L: "L",
  XL: "XL"
}, S = {
  XXS: "XXS",
  XS: "XS",
  S: "S",
  M: "M",
  L: "L",
  XL: "XL"
}, d = "span", l = {
  children: o.node,
  isUppercase: o.bool,
  size: o.oneOf(Object.values(a)),
  color: o.oneOf(Object.values(T)),
  component: o.oneOfType([o.string, o.elementType]),
  isBold: o.bool
}, X = {
  children: o.node,
  size: o.oneOf(Object.values(S)),
  color: o.oneOf(Object.values(T)),
  component: o.oneOfType([o.string, o.elementType])
}, i = ({
  color: t,
  size: n = a.S,
  isUppercase: h = !1,
  component: f,
  isBold: c = !1,
  ...y
}) => {
  const w = x(t);
  return g(f || d, {
    css: [
      r.text,
      r[`text${n.toUpperCase()}`],
      h && r.textuppercase,
      c && r.textBold,
      w.text
    ],
    ...y
  });
};
i.SIZES = a;
i.propTypes = l;
const m = ({
  size: t = S.L,
  color: n,
  component: h,
  ...f
}) => {
  const c = x(n);
  return g(h || d, {
    css: [r.display, r[`display${t.toUpperCase()}`], c.text],
    ...f
  });
};
m.SIZES = S;
m.propTypes = X;
const z = "h1", I = ({
  size: t = m.SIZES.S,
  ...n
}) => /* @__PURE__ */ p(m, { component: z, size: t, css: r.base, ...n });
I.propTypes = X;
const E = "h2", L = ({
  size: t = i.SIZES.M,
  ...n
}) => /* @__PURE__ */ p(i, { component: E, size: t, ...n });
L.propTypes = l;
const M = "div", R = ({
  size: t = i.SIZES.M,
  ...n
}) => /* @__PURE__ */ p(i, { component: M, size: t, ...n });
R.propTypes = l;
const O = "p", b = ({
  size: t = i.SIZES.S,
  ...n
}) => /* @__PURE__ */ p(i, { component: O, size: t, ...n });
b.propTypes = l;
const P = "p", $ = ({
  size: t = i.SIZES.S,
  ...n
}) => /* @__PURE__ */ p(i, { size: t, component: P, ...n });
$.propTypes = l;
export {
  b as Body,
  $ as Detail,
  m as Display,
  L as SectionHeading,
  R as SubTitle,
  i as Text,
  I as Title,
  r as styles
};
